module.exports = __webpack_public_path__ + "img/help36.91ba983e.png";